import React from 'react'
import './css/Contact.css'
import Navbar from '../components/Navbar'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { AiFillYoutube, AiFillInstagram, AiFillFacebook } from 'react-icons/ai'
import Footer from '../components/Footer'
import HomeMap from './../components/HomeMap'
import { Helmet } from 'react-helmet-async'

function Contact() {
  return (
    <div className='Contact'>

      <Helmet>
        <title>Contact Us | Plaza Catering Service</title>
        <meta name='description' content='Contact Us:  Reach out to Plaza Catering for exceptional catering and event management services. Let us make your occasion truly memorable.' />
        <link rel='canonical' href='/contact' />
      </Helmet>

      <div className='overlay'></div>
      <Navbar className='navbar' bgColor={"var(--maroon)"}/>
      <div className='content'>
          <h1>Contact Us</h1>
          <div className='cards'>
              <div className='card'>
                  <h2>Phone</h2>
                  <div className='field'><BsFillTelephoneFill/> <p>+91 9539 100 000</p></div>
                  <div className='field'><BsFillTelephoneFill/> <p>+91 9846 30 1234</p></div>
              </div>
              <div className='card'>
                  <h2>Address</h2>
                  <p>
                    Plaza Catering Service<br/>
                    Palakkad - Ponnani Rd<br/>
                    Vaniyamkulam-I<br/>
                    Palakkad Dist.<br/>
                    Kerala - 679 523
                  </p>
              </div>
              <div className='card'>
                  <h2>Social Media</h2>
                  <a href='https://www.youtube.com/@plazacateringservice9512' rel="noreferrer" target='_blank'><div className='field'><AiFillYoutube className='social'/> <p>Youtube</p></div></a>
                  <a href='https://www.instagram.com/plazacateringservice' rel="noreferrer" target='_blank'><div className='field'><AiFillInstagram className='social'/> <p>Instagram</p></div></a>
                  <a href='https://www.facebook.com/plaza.26/' rel="noreferrer" target='_blank'><div className='field'><AiFillFacebook className='social'/> <p>Facebook</p></div></a>
              </div>
          </div>
      </div>
      <HomeMap />
      <Footer />
    </div>
  )
}

export default Contact